import Vue from 'vue'
import VueRouter from 'vue-router'
import mspConfigurationManage from '@/views/mspConfigurationManage'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'wrapper',
    component: () => import('@/views/wrapper'),
    children: [
      {
        path: '/manuscriptrepo',
        name: 'manuscriptrepo',
        component: () => import('@/views/manuscriptrepo'),
        redirect: '/manuscriptrepo/lasteditor',
        children: [
          {
            path: 'lasteditor',
            name: 'lasteditor',
            component: () => import('@/views/lasteditor')
          },
          {
            path: 'mycollection',
            name: 'mycollection',
            component: () => import('@/views/mycollection')
          },
          {
            path: 'myshare',
            name: 'myshare',
            component: () => import('@/views/myshare')
          },
          {
            path: 'sharetome',
            name: 'sharetome',
            component: () => import('@/views/sharetome')
          },
          {
            path: 'myaudit',
            name: 'myaudit',
            component: () => import('@/views/myaudit')
          },
          {
            path: 'mysendaudit',
            name: 'mysendaudit',
            component: () => import('@/views/mysendaudit')
          },
          {
            path: 'mypush',
            name: 'mypush',
            component: () => import('@/views/mypush')
          },
          {
            path: 'repomanuscript',
            name: 'repomanuscript',
            component: () => import('@/views/repomanuscript')
          },
          {
            path: 'recyclebin',
            name: 'recyclebin',
            component: () => import('@/views/recyclebin')
          },

          {
            path: 'companyrecyclebin',
            name: 'companyrecyclebin',
            component: () => import('@/views/recyclebin')
          },
          {
            path: 'companylasteditor',
            name: 'companylasteditor',
            component: () => import('@/views/companylasteditor')
          }

        ]
      },

      {
        path: '/documentrepo',
        name: 'documentrepo',
        component: () => import('@/views/manuscriptrepo'),
        redirect: '/documentrepo/lasteditor',
        children: [
          {
            path: 'lasteditor',
            name: 'lasteditordoc',
            component: () => import('@/views/lasteditor')
          },
          {
            path: 'mycollection',
            name: 'mycollectiondoc',
            component: () => import('@/views/mycollection')
          },
          {
            path: 'myshare',
            name: 'mysharedoc',
            component: () => import('@/views/myshare')
          },
          {
            path: 'sharetome',
            name: 'sharetomedoc',
            component: () => import('@/views/sharetome')
          },
          {
            path: 'myaudit',
            name: 'myauditdoc',
            component: () => import('@/views/myaudit')
          },
          {
            path: 'mysendaudit',
            name: 'mysendauditdoc',
            component: () => import('@/views/mysendaudit')
          },
          {
            path: 'repomanuscript',
            name: 'repomanuscriptdoc',
            component: () => import('@/views/repomanuscript')
          },
          {
            path: 'recyclebin',
            name: 'recyclebindoc',
            component: () => import('@/views/recyclebin')
          },

          {
            path: 'companyrecyclebin',
            name: 'companyrecyclebin',
            component: () => import('@/views/recyclebin')
          },
          {
            path: 'companylasteditor',
            name: 'companylasteditor',
            component: () => import('@/views/companylasteditor')
          }

        ]
      },
      {
        path: '/statisticsQuery',
        name: 'statisticsQuery',
        component: () => import('@/views/statisticsQuery')
      },
      {
        path: '/intalligentSearch',
        name: 'intalligentSearch',
        component: () => import('@/views/intalligentSearch'),
        children: [
          {
            path: 'detail',
            name: 'searchDetail',
            component: () => import('@/views/searchDetail')
          }
        ]
      },
      {
        path: '/statementAnalysis',
        name: 'statementAnalysis',
        component: () => import('@/views/statementAnalysis'),
        children: [
          {
            path: 'person',
            name: 'person',
            component: () => import('@/components/statementAnalysis/analysisPerson')
          },
          {
            path: 'department',
            name: 'department',
            component: () => import('@/components/statementAnalysis/analysisDepartment')
          },
          {
            path: 'unit',
            name: 'unit',
            component: () => import('@/components/statementAnalysis/analysisUnit')
          }
        ]
      },
      {
        path: '/systemSet',
        name: 'systemSet',
        // redirect: '/systemSet/mspConfigurationManage',
        component: () => import('@/views/systemSet'),
        children: [
          {
            path: 'personalSet',
            name: 'personalSet',
            component: () => import('@/views/personalSet')
          },
          {
            path: 'mspConfigurationManage',
            component: mspConfigurationManage,
            redirect: 'mspConfigurationManage/mspConfiguration',
            children: [
              {
                path: 'mspConfiguration',
                name: 'mspConfiguration',
                component: () => import('@/views/mspConfiguration')
              },
              {
                path: 'documentManage',
                name: 'documentManage',
                component: () => import('@/views/documentManage')
              },
              {
                path: 'roleManage',
                name: 'roleManage',
                component: () => import('@/views/roleManage')
              },
            ]
          },
          {
            path: 'interfacePermissions',
            name: 'interfacePermissions',
            component: () => import('@/views/interfacePermissions')
          },
          {
            path: 'administratorList',
            name: 'administratorList',
            component: () => import('@/views/administratorList')
          },
          {
            path: 'reportPermissions',
            name: 'reportPermissions',
            component: () => import('@/views/reportPermissions')
          },
          {
            path: 'waterMarkManage',
            name: 'waterMarkManage',
            component: () => import('@/views/waterMarkManage')
          },
          {
            path: 'tagConfiguration',
            name: 'tagConfiguration',
            component: () => import('@/views/tagConfiguration')
          },
          {
            path: 'basicInformation',
            name: 'basicInformation',
            component: () => import('@/views/basicInformation')
          },
          {
            path: 'whitelistConfig',
            name: 'whitelistConfig',
            component: () => import('@/views/whitelistConfig')
          },
          {
            path: 'operatelog',
            name: 'operatelog',
            component: () => import('@/views/systemoperatelog')
          },
        ]
      },
      {
        path: '/personset',
        name: 'personset',
        component: () => import('@/views/personset'),
        redirect: '/personset/personeditor',
        children: [
          {
            path: 'personeditor',
            name: 'personeditor',
            component: () => import('@/views/personeditor')
          }
        ]
      },
    ]
  },
  {
    path: '/editorArticle',
    name: 'editorArticle',
    component: () => import('@/views/editorArticle')
    // children: [
    //   {
    //     path: 'child',
    //     component: child,
    //     meta: {
    //       requireAuth: true, //需要验证登录状态的组件
    //     },
    //   },
    // ]
  },
  {
    path: '/atlasmanuscript',
    name: 'atlasmanuscript',
    component: () => import('@/views/atlasmanuscript')
    // children: [
    //   {
    //     path: 'child',
    //     component: child,
    //     meta: {
    //       requireAuth: true, //需要验证登录状态的组件
    //     },
    //   },
    // ]
  },

  {
    path: '/auditMessage',
    name: 'auditMessage',
    component: () => import('@/views/auditmessage')
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

//解决页面停留半小时跳转路由页面卡死问题
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    location.reload()
  }
})
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
